export default {
  id: null,
  nome: '',
  itens: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/grouprefundtravel.js